import React from "react";
import { ErrorMessage, Field } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { RequiredFieldMarker } from "../../Forms/RequiredFieldMarker";

interface FormFieldProps {
    name: string;
    label: string;
    type: string;
    validate?: (value: string) => void;
    disabled?: boolean;
    inputRef?: React.Ref<HTMLInputElement>;
    required?: boolean;
}

export const InvitationAcceptanceFormField: React.FC<FormFieldProps> = ({
    name,
    label,
    type,
    validate,
    disabled = false,
    inputRef,
    required = true,
}) => {
    return (
        <Form.Group as={Row} className="mb-3" controlId={name}>
            <Form.Label column sm={3}>
                {label}
                {required && <RequiredFieldMarker />}
            </Form.Label>
            <Col sm={9}>
                <Field
                    name={name}
                    type={type}
                    validate={validate}
                    disabled={disabled}
                    innerRef={inputRef}
                    className="form-control"
                />
                <ErrorMessage
                    name={name}
                    component="div"
                    className="invalid-feedback"
                />
            </Col>
        </Form.Group>
    );
};
